import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

// Adjunta el JWT en cada petición
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Si el token expira/inválido en un endpoint protegido, cerrar sesión
http.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("token")) {
      localStorage.removeItem("token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const apiLogin = (data) => http.post("/auth/login", data).then((r) => r.data);
export const getMe = () => http.get("/auth/me").then((r) => r.data);

// Usuarios (admin)
export const getUsers = () => http.get("/users").then((r) => r.data);
export const createUser = (data) => http.post("/users", data).then((r) => r.data);
export const updateUser = (id, data) => http.put(`/users/${id}`, data).then((r) => r.data);
export const deactivateUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);

// Juegos
export const getGames = (params) => http.get("/games", { params }).then((r) => r.data);
export const getGame = (id) => http.get(`/games/${id}`).then((r) => r.data);
export const createGame = (data) => http.post("/games", data).then((r) => r.data);
export const updateGame = (id, data) => http.put(`/games/${id}`, data).then((r) => r.data);
export const deactivateGame = (id) => http.delete(`/games/${id}`).then((r) => r.data);

// Sorteos
export const getDraws = (params) => http.get("/draws", { params }).then((r) => r.data);
export const getDraw = (id) => http.get(`/draws/${id}`).then((r) => r.data);
export const createDraw = (data) => http.post("/draws", data).then((r) => r.data);
export const runDraw = (id) => http.post(`/draws/${id}/run`).then((r) => r.data);
export const revealDraw = (id) => http.post(`/draws/${id}/reveal`).then((r) => r.data);
export const verifyDraw = (id) => http.get(`/draws/${id}/verify`).then((r) => r.data);
export const actaPdfUrl = (id) => `${API}/draws/${id}/acta.pdf`;
export const bundleZipUrl = (id) => `${API}/draws/${id}/bundle.zip`;

// Verificador público
export const verifyPublic = (data) => http.post("/verify", data).then((r) => r.data);

// Guía técnica (acceso protegido)
export const verifyGuia = (password) => http.post("/guia/verify", { password }).then((r) => r.data);

// Expediente legal (acceso protegido — descargas ordenadas para SENCAMER)
export const verifyExpediente = (password) =>
  http.post("/expediente/verify", { password }).then((r) => r.data);
export const getExpedienteManifiesto = (password, juego = "triple") =>
  http.get("/expediente/manifiesto", { params: { password, juego } }).then((r) => r.data);
export const expedienteDownloadUrl = (item, password, juego = "triple") =>
  `${API}/expediente/download?item=${encodeURIComponent(item)}&password=${encodeURIComponent(password)}&juego=${encodeURIComponent(juego)}`;

// Bitácora / auditoría / stats
export const getLedger = (params) => http.get("/ledger", { params }).then((r) => r.data);
export const verifyLedger = () => http.get("/ledger/verify").then((r) => r.data);
export const getAuditEvents = (params) => http.get("/audit-events", { params }).then((r) => r.data);
export const getStats = () => http.get("/stats").then((r) => r.data);
